<template>
  <div class="w-full">
    <div class="flex flex-row items-center py-2">
      <div class="flex-1 flex flex-row items-center space-x-5">
        <slot name="title" />
        <my-button v-if="editable" :type="'default'" size="default" @click="handleCreate" icon="plus">{{ createText }}</my-button>
        <slot name="actions" />
      </div>
      <div class="form-control">
        <div class="input-group">
          <input :value="getSearchValue('text')" @input="setSearchValue('text', $event.target.value)" @keydown.enter="handleSearch()" type="text" name="TableSearch" placeholder="Хайх..." class="input input-bordered">
          <my-button square icon="search" size="default" type="default" @click="handleSearch"></my-button>
        </div>
      </div>
    </div>
    <div class="overflow-x-auto border border-base-300 rounded-lg w-full">
      <table class="text-sm w-full">
        <thead>
          <tr :class="trhClass">
            <th :class="thClass">№</th>
            <td :class="tdSearchClass" v-if="selectType === 'single'"></td>
            <template v-for="header in headers.filter(c => !c.group)" :key="header.name">
              <th :width="header.width" :class="thClass" class="cursor-pointer" @click="handleSort(header.name)">
                <div class="flex flex-row items-center">
                  <span class="flex-1 leading-4">{{ header.caption }}</span>
                  <span class="ml-2" v-if="sort.some(c => c.name === header.name)">
                    <label class="swap">
                      <input type="checkbox" :checked="sort.find(c => c.name === header.name).type === 'ASC'" />
                      <span class="swap-on">
                        <hero-icon :name="`sort-ascending`" />
                      </span>
                      <span class="swap-off">
                        <hero-icon :name="`sort-descending`" />
                      </span>
                    </label>
                  </span>
                </div>
              </th>
            </template>
            <th v-if="!hideActions" width="90" :class="thClass" align="center">#</th>
          </tr>
          <tr :class="[trhClass]">
            <td :class="tdSearchClass" width="50px"></td>
            <td :class="tdSearchClass" v-if="selectType === 'single'"></td>
            <template v-for="header in headers.filter(c => !c.group)" :key="header.name">
              <td :class="tdSearchClass">
                <table-input
                  :modelValue="getSearchValue(header.prop || header.name)"
                  @update:modelValue="setSearchValue(header.prop || header.name, $event)"
                  :header="header"
                  size="small"
                  placeholder="хайх.."
                  @enter="handleSearch"
                />
              </td>
            </template>
            <td v-if="!hideActions" :class="tdSearchClass" align="center">
              <my-button icon="refresh" type="ghost" square size="small" @click="handleRefresh()"></my-button>
            </td>
          </tr>
        </thead>
        <tbody class="relative" style="min-height: 300px">
          <tr :class="trClass" v-if="rows.length === 0 && !loading">
            <td :class="tdClass" colspan="100%" align="center">
              <div class="w-72">
                <my-alert>Өгөгдөл хоосон байна.</my-alert>
              </div>
            </td>
          </tr>
          <template v-for="(r, i) in rows" :key="r.id">
            <tr class="bg-base-300" v-if="group && (i === 0 || getValue(r, group.name) !== getValue(rows[i - 1], group.name))" :class="trClass">
              <td colspan="100%" :class="tdClass">{{ group.caption }}: <span class="font-bold">{{ getValue(r, group.name) || group.placeholder }}</span></td>
            </tr>
            <tr :class="trClass" class="hover:bg-base-300" @click="handleRowclick(r)" @dblclick.stop="handleRowDblclick(r)">
              <td :class="tdClass" align="right" width="50px">{{ (query.page - 1) * query.limit + i + 1 }}</td>
              <td v-if="selectType === 'single'" :class="[tdClass, 'px-1']" align="center" width="40.5px" >
                <div class="flex align-center justify-center">
                  <input type="radio" name="radio-1" class="radio" @click="selected = r" :checked="selected && selected.id === r.id">
                </div>
              </td>
              <template v-for="header in headers.filter(c => !c.group)" :key="header.name">
                <td :class="tdClass" :align="header.align" :width="header.width">
                  <div class="whitespace-nowrap text-ellipsis overflow-hidden" :style="{width: header.width ? header.width + 'px' : undefined }">
                    <span v-if="header.type === 'currency'">
                      {{ getValue(r, header.name, header.type) }}
                    </span>
                    <span v-else-if="header.type === 'Success'">
                      <span v-if="getValue(r, header.name)">
                        <span class="text-green-500">Амжилттай</span>
                      </span>
                      <span v-else>
                        <span class="text-red-500">Амжилтгүй</span>
                      </span>
                    </span>
                    <span v-else-if="header.type === 'Boolean'">
                      <span v-if="getValue(r, header.name)">
                        <hero-icon v-if="header.iconTrue" :name="header.iconTrue" />
                        <span>Тийм</span>
                      </span>
                      <span v-else>
                        <hero-icon v-if="header.iconFalse" :name="header.iconFalse" />
                        <span>Үгүй</span>
                      </span>
                    </span>
                    <span v-else-if="header.type === 'Date'">{{ getValue(r, header.name) ? moment(getValue(r, header.name)).format('YYYY-MM-DD') : 'Утга байхгүй' }}</span>
                    <span v-else :class="header.color ? `text-${getValue(r, header.color)}` : {}">
                      <span v-if="header.icon"><hero-icon :name="getValue(r, header.icon)" /></span>
                      {{ getValue(r, header.name) }}
                    </span>
                  </div>
                </td>
              </template>
              <td v-if="!hideActions" :class="[tdClass, 'whitespace-nowrap']" align="center">
                <my-button size="small" icon="pencil" type="ghost" square @click.stop="handleEdit(r.id)"></my-button>
                <my-button v-if="editable" size="small" icon="trash" type="ghost" square @click.stop="handleDelete(r.id)"></my-button>
              </td>
            </tr>
          </template>
          <tr v-if="loading && rows.length === 0" :class="trClass">
            <td :class="[tdClass, 'h-16']" colspan="100%" align="center">
            </td>
          </tr>
          <tr v-if="loading" class="absolute w-full h-full top-0 left-0 bg-base-300 bg-opacity-75 place-items-center">
            <div class="w-full h-full flex items-center justify-center" colspan="100%">Уншиж байна...</div>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="flex items-center flex-wrap justify-end w-full pt-5 space-x-6">
      <div class="flex-1 flex flex-row space-x-6">
        <my-button outline>Нийт: {{ total }}</my-button>
        <div>
          <my-input class="w-16 center" v-model.number="limit" @change="handleChangeLimit"></my-input>
        </div>
        <my-pagination v-if="query" :page="query.page" :limit="query.limit" :total="total" @change="handleChangePage" />
      </div>
      <slot name="footer" />
    </div>
  </div>
</template>
<script>
import * as _ from 'lodash'
import MyPagination from './MyPagination.vue'
export default {
  components: {
    MyPagination
  },
  props: {
    loading: { type: Boolean, default: false },
    headers: { type: Array, default: () => { return [] } },
    data: { type: Array, default: () => { return [] } },
    query: { type: Object },
    editable: { type: Boolean, default: true },
    hideActions: { type: Boolean, default: false },
    selectType: { type: String, default: 'none' },
    selectedRow: { type: Object, default: () => { return null } },
    createText: { type: String, default: 'Бүртгэх' }
  },
  data () {
    return {
      thClass: 'px-2 py-2 border-r border-base-300 last:border-r-0',
      tdSearchClass: 'p-0 border-r border-base-300 last:border-r-0',
      tdClass: 'px-2 py-1 border-r border-base-300 last:border-r-0',
      trhClass: 'border-b border-base-300',
      trClass: 'border-b border-base-300 last:border-b-0',
      limit: 0
    }
  },
  computed: {
    rows () {
      return _.get(this.data, '[0]') || []
    },
    total () {
      return _.get(this.data, '[1]') || 0
    },
    group () {
      return _.find(this.headers, { group: true })
    },
    modelQuery: {
      get () {
        return this.query
      },
      set (val) {
        this.$emit('update:query', val)
      }
    },
    sort () {
      return this.modelQuery.sort
    },
    selected: {
      get () {
        return this.selectedRow
      },
      set (val) {
        this.$emit('update:selectedRow', Object.assign({}, val))
      }
    }
  },
  created () {
    this.limit = this.query.limit
  },
  methods: {
    handleChangeLimit () {
      if (isNaN(this.limit)) {
        this.limit = this.query.limit
      } if (this.limit <= 0) {
        this.$emit('change-limit', 15)
      } else {
        this.$emit('change-limit', this.limit)
      }
    },
    getValue (row, name, type) {
      if (name.includes('{') && name.includes('}')) {
        let valueStr = name
        const strs = name.split('{')
        for (const str of strs) {
          const indx = str.indexOf('}')
          if (indx !== -1) {
            const value = _.get(row, str.slice(0, indx)) || ''
            valueStr = valueStr.replace(`{${str.slice(0, indx)}}`, value)
          }
        }
        return valueStr.trim()
      } else {
        const value = _.get(row, name)
        if (type === 'currency') {
          return '₮ ' + String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        }
        return value
      }
    },
    getSearchValue (name) {
      if (!this.query) {
        return null
      }
      const search = this.query.search.find(c => c.name === name)
      return search ? search.value : null
    },
    handleChangePage (val) {
      this.$emit('change-page', val)
    },
    setSearchValue (name, $event) {
      const query = Object.assign({}, this.query)
      const search = query.search.find(c => c.name === name)
      if (search) {
        search.value = $event
      } else {
        query.search.push({ name, value: $event })
      }
      this.modelQuery = query
    },
    handleRefresh () {
      this.$emit('refresh')
    },
    handleSearch () {
      this.$emit('search')
    },
    handleCreate () {
      if (typeof this.$attrs.onCreate === 'function') {
        this.$emit('create')
      } else {
        this.$router.push({ name: this.$route.name + '-detail', params: { id: 'create' } })
      }
    },
    handleRowclick (row) {
      this.$emit('row-click', row)
      this.selected = row
    },
    handleRowDblclick (row) {
      this.$emit('row-dblclick', row)
      this.handleEdit(row.id)
    },
    handleEdit (id) {
      if (typeof this.$attrs.onEdit === 'function') {
        this.$emit('edit', id)
      } else {
        this.$router.push({ name: this.$route.name + '-detail', params: { id } })
      }
    },
    handleDelete (id) {
      this.$emit('delete', id)
    },
    handleSort (name) {
      const query = Object.assign({}, this.query)
      const item = query.sort.find(c => c.name === name)
      if (item) {
        if (item.type === 'ASC') {
          item.type = 'DESC'
        } else {
          const index = query.sort.findIndex(c => c.name === name)
          query.sort.splice(index, 1)
        }
      } else {
        query.sort.splice(0)
        query.sort.push({ name, type: 'ASC' })
      }
      this.modelQuery = query
      this.$emit('search')
    }
  }
}
</script>
